import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { CardTemplateAttributeDb } from '../redux/cardTemplateAttributeDbSlice';

const useCardTemplateAttributeDbs = (cardTemplateId: string): [string[], CardTemplateAttributeDb[]] => {
  const cardTemplateAttributeDb = useSelector((state: RootState) => state.cardTemplateAttributeDb);
  const ids = Object.keys(cardTemplateAttributeDb.cardTemplateAttributes).filter(id => cardTemplateAttributeDb.cardTemplateAttributes[id].cardTemplateId === cardTemplateId);
  ids.sort((a, b) => {
    const aValue = cardTemplateAttributeDb.cardTemplateAttributes[a];
    const bValue = cardTemplateAttributeDb.cardTemplateAttributes[b];
    return bValue.z - aValue.z;
  })
  const values = ids.map(id => cardTemplateAttributeDb.cardTemplateAttributes[id]);

  return [ids, values];
}

export default useCardTemplateAttributeDbs;
